import { render } from "./GridParteneriComercial.vue?vue&type=template&id=c8e3e86e&ts=true"
import script from "./GridParteneriComercial.vue?vue&type=script&lang=ts"
export * from "./GridParteneriComercial.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__